import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

const HeroSection = () => {
  return (
    <header className="text-center space-y-6">
      <span className="inline-block bg-racing-accent/20 text-racing-accent text-sm font-medium px-3 py-1 rounded-full mb-4">
        Learn
      </span>
      <motion.h1 
        className="text-4xl md:text-7xl font-black"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        Frequently Asked <span className="text-racing-accent">Questions</span>
      </motion.h1>
      <motion.p 
        className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
      >
        Everything you need to know about <b>FR:RM</b>
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.6 }}
      >
        <ChevronDown className="w-6 h-6 mx-auto text-racing-accent animate-bounce" />
      </motion.div>
    </header>
  );
};

export default HeroSection; 